// extracted by mini-css-extract-plugin
export default {"resLoading":"resLoading_cFeID6","loading":"loading_0m5dzE","rotate":"rotate_8peLCN","loadingText":"loadingText_dQOvKl"};